import Humanize from 'humanize-plus';

export const FileTreeFile = ({ file, parent, setPath, getImage }) => {

    const path = file.path.replace(file.name, '').substr(0, file.path.replace(file.name, '').length - 1);

    const pathData = { path: path, contents: parent.contents, parent: parent };

    return (
        <div style={{ cursor: 'pointer' }} className="file-node" onClick={e => { e.stopPropagation(); setPath(pathData); }}>
            <a href="#/" className="file-link">
                <span className="file-arrow"></span>
                <span title={`${file.path} (${Humanize.fileSize(file.size)})`} className="file-info">
                    <span className="file-icon"><i className={`far ${getImage(file.contentType).icon} fa-lg text-body text-opacity-50`}></i></span>
                    <span className="file-text">{file.name}</span>
                </span>
            </a>
        </div>
    );
};